import { forwardRef } from "react";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";

import { DatePickerProps } from "./types";

export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(
  ({ name, label, value, required, error, helperText, disabled, onChange, ...props }, ref) => {

    return (
      <MuiDatePicker
        inputRef={ref}
        name={name}
        label={label}
        value={value ? new Date(value) : value}
        onChange={onChange}
        sx={{
          "& .MuiInputBase-root": {
            height: "45px",
          },
          "& .MuiInputBase-input": {
            fontSize: 14,
            padding: "8px 12px",
          },
        }}
        disabled={disabled}
        slotProps={{
          field: {
            clearable: true,
            onClear: () => onChange?.(null),
          },
          textField: {
            required,
            error,
            helperText,
            fullWidth: true,
          },
        }}
        {...props}
      />
    );
  }
);

DatePicker.displayName = "DatePicker";
